export default "/images/nextempleamar-logo.png?3ebdd2ad9fe7c776f0388ca49084c6b0";